import { useForm } from 'react-hook-form';
import { RepQuoteFormState } from 'shared/types/quotes';
import { defaultQuoteState } from 'shared/constants/quotes';
import { BasicQuoteForm } from './basic-quote-form';

export function NewQuote() {
  const methods = useForm<RepQuoteFormState>({
    defaultValues: defaultQuoteState,
  });

  return <BasicQuoteForm methods={methods} />;
}
